export const deleteButton = {
  background: "red",
  padding: "1em",
  margin: "1em",
};

export const updateButton = {
  background: "orange",
  padding: "1em",
  margin: "1em",
};

export const loginButton = {
  background: "royalblue",
  padding: "1em",
  margin: "1em",
};

export const logoutButton = {
  padding: "1em",
  margin: "1em",
};

export const linkStyle = {
  textDecoration: "none",
  color: "white",
};

export const registerButton = {
  background: "green",
  padding: "1em",
  margin: "1em",
};

export const homeButton = {
  background: "mediumpurple",
  padding: "1em",
  margin: "1em",
};

export const saveButton = {
  background: "green",
  padding: "1em",
  margin: "1em",
};

export const cancelButton = {
  background: "magenta",
  padding: "1em",
  margin: "1em",
};

export const forgotButton = {
  background: "purple",
  padding: "1em",
  margin: "1em",
};

export const inputStyle = {
  margin: ".5em",
};

const buttonStyles = {
  deleteButton,
  updateButton,
  loginButton,
  logoutButton,
  forgotButton,
  linkStyle,
  registerButton,
  homeButton,
  inputStyle,
  saveButton,
  cancelButton,
};

export default buttonStyles;
